import { formatCloseTemplateDateRange } from "@components/settings/OrganizationCloseTemplates/formatCloseTemplateDateRange";

/** A task update that sets its service; clearing the service clears its stage too. */
export const getServiceUpdate = (closeId: string | null) => ({
    closeId,
    ...(!closeId && { closeStageId: null }),
});

/** A close option's "entity · date range" line, or undefined with neither. */
export const getCloseOptionDescription = ({
    entityName,
    startDate,
    endDate,
}: {
    entityName: string | undefined;
    startDate?: string | null;
    endDate?: string | null;
}) => {
    const dateRange =
        startDate != null || endDate != null
            ? formatCloseTemplateDateRange(startDate ?? null, endDate ?? null)
            : undefined;
    const descriptionParts = [entityName, dateRange].filter(
        (part): part is string => Boolean(part),
    );
    return descriptionParts.length > 0
        ? descriptionParts.join(" · ")
        : undefined;
};
